export const CollapsibleStyles = ({ theme }) => `
  height: auto;
  overflow-y: auto;
  padding: 5px 20px 5px 10px;
  margin-bottom: 10px;
`;
